import createGetFormAsyncErrors from './selectors/getFormAsyncErrors';
import plain from './structure/plain';

export default createGetFormAsyncErrors(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/getFormAsyncErrors.js
// module id = 1750
// module chunks = 2